<div class="contact-card-container">
  <div class="organized-by-title">Organized By</div>
  <div class="carousel-container m-auto contact-carousel">
    <owl-carousel-o [options]="customOptions">
      <ng-template carouselSlide>
        <!-- TODO:In case the cards did change to be array of object we would need to use *ngFor -->
        <div class="wrapper">
          <div class="card-container">
            <div class="left-section position-relative">
              <span *ngIf="!contactList?.contactInfo?.company_logo" class="mb-1 initials d-flex justify-content-center align-items-center"
                ><p>{{ initials }}</p></span
              >
              <img *ngIf="contactList?.contactInfo?.company_logo" class="mb-1" width="67px" height="67px" [src]="contactList?.contactInfo?.company_logo" alt="" />
              <h3 class="name">{{ contactList?.contactInfo?.company_name }}</h3>
            </div>
            <div class="right-section d-flex flex-column">
              <div *ngIf="contactList?.contactInfo?.company_phone" class="d-flex align-items-center">
                <div class="image-container"><img src="https://library.micetribe.com/icons/phone-xs-black.svg" alt="" /></div>
                <span> {{ contactList?.contactInfo?.company_phone }}</span>
              </div>
              <div *ngIf="contactList?.contactInfo?.company_email" class="d-flex align-items-center">
                <div class="image-container"><img src="https://library.micetribe.com/icons/email-xs-black.svg" alt="" /></div>
                <a href="mailto:{{ contactList?.contactInfo?.company_email }}">
                  <span data-toggle="tooltip" data-placement="top" [title]="contactList?.contactInfo?.company_email"> {{ contactList?.contactInfo?.company_email }}</span>
                </a>
              </div>
              <div *ngIf="contactList?.contactInfo?.company_address" class="d-flex align-items-center">
                <div class="image-container"><img src="https://library.micetribe.com/icons/pin-xs-black.svg" alt="" /></div>
                <span> {{ contactList?.contactInfo?.company_address }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>
</div>
